import React, { useState, useEffect } from 'react';
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { ProjectActionTypes } from '../../redux/project/project.types';
import Header from '../../components/home/header/header.component';
import GreenLine from '../../components/greenline/greenline.component';
import FooterNew from '../../components/footernew/footernew.component';
import { removeFirstChar } from '../../utils/utils';
import { language as MAINLANG } from '../../utils/lang';
import './iletisim.page.styles.scss';

const IletisimPage = () => {
  const xprops = useSelector(state => state);
  const dispatch = useDispatch();
  const [mounted, setMounted] = useState(false);
  const setParent = (value) => dispatch({type: ProjectActionTypes.SET_PARENT, value: value });  
  
  
  if(!mounted){
    if (xprops.language === undefined){
      setParent(removeFirstChar(MAINLANG.TR.routes.contactUs));  
    }else{
      setParent(removeFirstChar(xprops.language.routes.contactUs));  
    }
  }

  useEffect(() =>{
    setMounted(true);
    window.scrollTo(0,0);
  },[]);  

    return(
      <React.Fragment>
        <div className="homeWrapper">
          <Header />
          <div className="newSectionWrapper">
          <GreenLine classx="spacebottom"/>
          <div className="newContentLayerWrapper">
            <div className="subContentSectionWrapper">
              <h1 className="subContentTitle">{xprops.project.language.keywords.contactUs}</h1>
              <p className="iletisimParagragh">
                {xprops.project.language.keywords.soruMesajlar}<br/>
                info@sensizolmazsessizolmaz.org
              </p>

              <h4><a href={xprops.project.language.routes.faq} className="SSSLink">{xprops.project.language.keywords.sıkSorulanSorular}</a></h4>

              <ul className="iletisimUl">
                <li><a target="_blank"  rel="noopener noreferrer" href="mailto:info@sensizolmazsessizolmaz.org"><i className="far fa-envelope"></i></a></li>
                <li><a target="_blank"  rel="noopener noreferrer" href="https://www.instagram.com/sensizolmazorg/"><i className="fab fa-instagram"></i></a></li>
                <li><a target="_blank"  rel="noopener noreferrer" href="https://www.youtube.com/channel/UCc1IMJQYrM7FfYs2zFgTjOA"><i className="fab fa-youtube"></i></a></li>
                <li><a target="_blank"  rel="noopener noreferrer" href="https://twitter.com/sensizolmazorg"><i className="fab fa-twitter"></i></a></li>
                <li><a target="_blank"  rel="noopener noreferrer" href="https://www.linkedin.com/company/sensizolmazorg"><i className="fab fa-linkedin"></i></a></li>
              </ul>
            </div>
 
          </div>
        </div>
          
        </div>
        <FooterNew />
      </React.Fragment>
    );
};

export default IletisimPage;